import {
  PlatformCreateType,
  PlatformType,
  PlatformUpdateType,
} from "types/platform-types";

import { axios } from "./baseAxios";

const BE_URI = process.env.REACT_APP_BE_URI;

export const get = async ({
  code,
  name,
}: {
  code?: string;
  name?: string;
}): Promise<PlatformType[]> => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${BE_URI}/platforms`,
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      code,
      name,
    },
  };

  const response = await axios.request(config);
  return response?.data;
};

export const create = async (data: PlatformCreateType) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${BE_URI}/platforms`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  const response = await axios.request(config);
  return response?.data;
};

export const update = async (data: PlatformUpdateType) => {
  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${BE_URI}/platforms/${data?.code ?? ""}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  const response = await axios.request(config);
  return response?.data;
};

export const remove = async (code: string) => {
  let config = {
    method: "delete",
    maxBodyLength: Infinity,
    url: `${BE_URI}/platforms/${code ?? ""}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.request(config);
  return response?.data;
};

export const mappingUser = async (code: string, bots: string[]) => {
  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${BE_URI}/platforms/mapping/${code ?? ""}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ bots }),
  };

  const response = await axios.request(config);
  return response?.data;
};

export const getMappingBotInfo = async (code: string) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${BE_URI}/platforms/mapping/${code ?? ""}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.request(config);
  return response?.data;
};
